module.exports = __webpack_public_path__ + "img/unlockables.dfe35e1b.png";